import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  text-align: ${({ align }) => align || 'center'};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Eyebrow = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.4em;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
`;

const Title = styled.h2`
  font-size: clamp(32px, 4vw, 44px);
  line-height: 1.2;
  color: ${({ theme }) => theme.text_primary};
  margin: 0;
`;

const Description = styled.p`
  font-size: 18px;
  color: ${({ theme }) => theme.text_secondary};
  margin: 0;
`;

const SectionHeading = ({ eyebrow, title, description, align = 'center' }) => (
  <Wrapper align={align}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
  </Wrapper>
);

export default SectionHeading;

